import React from "react";
import { useTranslation } from "react-i18next";

import DefaultNavigation from "../DefaultPage/DefaultPageComponents/DefaultNavigation/DefaultNavigation";
import DefaultHome from "../DefaultPage/DefaultPageSections/DefaultHome/DefaultHome";
import About from "../DefaultPage/DefaultPageSections/About/About";
import AiServices from "./AiServices/AiServices";
import Form from "../DefaultPage/DefaultPageComponents/Form/Form";
import Footer from "../DefaultPage/DefaultPageComponents/Footer/Footer";

const AiServicesPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <DefaultNavigation
        navItems={[
          {
            label: t("defaultPage_nav.about"),
            sectionId: "about_section",
            type: "button",
          },
          {
            label: t("defaultPage_nav.services"),
            sectionId: "ai_services_section",
            type: "button",
          },
        ]}
      />
      <DefaultHome />
      <About />
      <AiServices />
      <Form />
      <Footer />

    </>
  );
};

export default AiServicesPage;
